import type { SVGProps } from "react";

export function IconDarkPurpleBenchmarks(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0937 3.09375H30.4062V13.4062H28.3437V6.61466L19.75 15.2084L14.25 9.70841L3.59375 20.3646V17.4478L14.25 6.79159L19.75 12.2916L26.8853 5.15625H20.0937V3.09375ZM3.59375 29.9062V24.7399L5.65625 22.6774L5.65625 27.8438H11.8438V16.4899L13.9062 14.4274V27.8438H20.0938V19.2399L22.1562 17.1774V27.8438H28.3438V16.5002H30.4062V29.9062H3.59375Z"
        fill="#3E2247"
      />
    </svg>
  );
}
